/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:middle}.info-collection[_ngcontent-%COMP%]   strong[_ngcontent-%COMP%]{text-transform:capitalize}"];
export { styles as styles };
